export type ReceivedProps = Record<string, any>;

const useWorkerListCategoryStatus = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useWorkerListCategoryStatus>;

export default useWorkerListCategoryStatus;
